import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// Explicit confirmation before the only bulk transition that exists (assign). Lists exactly what will change.
export function BulkAssignConfirm({ open, onOpenChange, rows, staffName, onConfirm, busy }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="bulk-assign-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>Assign {rows.length} open enquir{rows.length === 1 ? "y" : "ies"} to {staffName}?</AlertDialogTitle>
          <AlertDialogDescription>Each enquiry is assigned and audited individually. Completed or cancelled enquiries are never changed and will be reported as skipped.</AlertDialogDescription>
        </AlertDialogHeader>
        <ul data-testid="bulk-assign-confirm-list" className="max-h-48 space-y-1 overflow-y-auto rounded-md border border-jigsaw-border bg-jigsaw-bg px-3 py-2 text-[13px]">
          {rows.map((r) => <li key={r.id} className="flex justify-between gap-3"><span className="font-mono-ref font-semibold text-jigsaw-navy">{r.jigsaw_reference}</span><span className="truncate text-jigsaw-muted">{r.client_name}{r.assigned_staff_name ? ` · currently ${r.assigned_staff_name}` : " · unassigned"}</span></li>)}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="bulk-assign-cancel-button">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="bulk-assign-confirm-button" disabled={busy} onClick={onConfirm}>{busy ? "Assigning…" : "Confirm assignment"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
